<template>
  <BaseButton2
    class="base-modal-button"
    @click="(event) => openModal(modal, event)"
    :disabled
  >
    <slot />
  </BaseButton2>
</template>

<script lang="ts" setup>
interface Props {
  modal: string;
  disabled?: boolean;
}

defineProps<Props>();

const { openModal } = useModalStore();
</script>
